import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  PLATFORM_ID
} from '@angular/core';
import { Location } from '@angular/common';
import { KazaplanFullscreenService } from '../kazaplan-fullscreen.service';
import { switchMap } from 'rxjs/operators';
import { OnDestroyComponent } from '../../../../shared/components/on-destroy/on-destroy.component';
import { Router } from '@angular/router';
import { AutoUnsubscribe } from '../../../../utils/misc/auto-unsubscribe';
import { from, Observable, Subscription } from 'rxjs';
import { ToastrService } from '../../../../shared/services/utilities/toastr.service';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';
import { KazaplanService } from '../../kazaplan.service';
import {NEVER} from "rxjs/internal/observable/never";
import { KazaPlanService, Media } from '@adeo/ngx-kozikaza-api/kazaplan';

@Component({
  selector: 'app-kazaplan-fullscreen',
  templateUrl: './kazaplan-fullscreen.component.html',
  styleUrls: ['./kazaplan-fullscreen.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers:[KazaPlanService]
})
@AutoUnsubscribe()
export class KazaplanFullscreenComponent extends OnDestroyComponent implements OnInit, OnDestroy {

  @Input() planId: string = null;
  @Input() mediaId: string = null;

  protected kazaplanMediasSubscription: Subscription;

  constructor(
    protected toastrService: ToastrService,
    protected cdr: ChangeDetectorRef,
    protected location: Location,
    public kfs: KazaplanFullscreenService,
    protected router: Router,
    @Inject(PLATFORM_ID) protected platformId,
    protected readonly localizeRouterService: LocalizeRouterService,
    protected readonly kazaplanService: KazaplanService,
    private readonly KazaPlanService:KazaPlanService
  ) {
    super();
  }

  ngOnInit() {
    if (this.planId) {
      this.kfs.modeLight = false;
      this.cdr.detectChanges();
      this.kazaplanMediasSubscription = (this.KazaPlanService.getPlanById(this.planId)).pipe(
        switchMap((plan) => { 
          this.kfs.currentKazaplan = plan;
          return this.initPlanMedias();
        })
      ).subscribe();
    }
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    if (this.kazaplanMediasSubscription) {
      this.kazaplanMediasSubscription.unsubscribe();
    }
  }

  protected initPlanMedias(): Observable<Media[]> {
    return this.kfs.initPlanMedias(this.mediaId);
  }
}
